export enum BrandTheme {
  Ayvens = 'ayvens',
  LeasePlan = 'leaseplan',
}
